import { MessagingHelper } from "../helpers/MessagingHelper";
import { APIService } from "./APIService";
import { AssistanceCheckListTaskDTO } from "../models/AssistanceCheckListTask/AssistanceCheckListTaskDTO";
import { EditAssistanceCheckListTaskDTO } from "../models/AssistanceCheckListTask/EditAssistanceCheckListTaskDTO";

export class AssistanceCheckListTaskService {

    async GetTaskById(id: number): Promise<MessagingHelper<AssistanceCheckListTaskDTO | null>> {
        try {
            const response = await APIService.Axios().get(
                `${APIService.GetURL()}/AssistanceCheckListTask/${id}`,
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<null>(
                false,
                "Erro ao obter a associação entre a task",
                null
            );
        }
    }

    async ConcludeTask(
        assistanceChecklistUpdate: EditAssistanceCheckListTaskDTO
    ): Promise<MessagingHelper<null>> {
        try {
            const response = await APIService.Axios().post(
                `${APIService.GetURL()}/AssistanceCheckListTask/ConcludeTask`,
                { ...assistanceChecklistUpdate },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<null>(
                false,
                "Erro ao concluir tarefa",
                null
            );
        }
    }

    async ConcludeTaskWithError(
        assistanceChecklistUpdate: EditAssistanceCheckListTaskDTO
    ): Promise<MessagingHelper<null>> {
        try {
            const response = await APIService.Axios().post(
                `${APIService.GetURL()}/AssistanceCheckListTask/ConcludeTaskWithError`,
                { ...assistanceChecklistUpdate },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<null>(
                false,
                "Erro ao concluir tarefa",
                null
            );
        }
    }

    async ConcludeTaskWithObservation(
        assistanceChecklistUpdate: EditAssistanceCheckListTaskDTO
    ): Promise<MessagingHelper<null>> {
        try {
            const response = await APIService.Axios().post(
                `${APIService.GetURL()}/AssistanceCheckListTask/ConcludeTaskWithObservation`,
                { ...assistanceChecklistUpdate },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<null>(
                false,
                "Erro ao concluir tarefa",
                null
            );
        }
    }


    async UndoTaskAction(
        assistanceChecklistUpdate: EditAssistanceCheckListTaskDTO
    ): Promise<MessagingHelper<null>> {
        try {
            const response = await APIService.Axios().post(
                `${APIService.GetURL()}/AssistanceCheckListTask/UndoTaskAction`,
                { ...assistanceChecklistUpdate },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<null>(
                false,
                "Erro ao desfazer tarefa",
                null
            );
        }
    }


    async EditObservation(
        assistanceChecklistUpdate: EditAssistanceCheckListTaskDTO
    ): Promise<MessagingHelper<null>> {
        try {
            const response = await APIService.Axios().post(
                `${APIService.GetURL()}/AssistanceCheckListTask/EditObservation`,
                { ...assistanceChecklistUpdate },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<null>(
                false,
                "Erro ao editar observação da tarefa",
                null
            );
        }
    }


    


}


